import React, { type ReactElement } from 'react';
import Alert from 'atom-components/alert';
import ConfirmModal, { ConfirmModalActionPair } from 'atom-components/confirm-modal';
import FullName from 'feature-components/full-name';
import { countMessages } from 'pages/marking/helpers/marker.helpers';
import type { ChangeMarkerMark } from 'pages/marking/types';
import type { PartialOrganisationUserWithPartialUser } from 'services/assist-api/entities/customer-user/types';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  oldMarkerId: number;
  oldOrganisationUser: PartialOrganisationUserWithPartialUser;
  marksOfResponse: ChangeMarkerMark[];
};

export default function ConfirmDeletionOfMarkingWorkModal({
  isOpen,
  onClose,
  onConfirm,
  oldMarkerId,
  oldOrganisationUser,
  marksOfResponse
}: Props): ReactElement {
  return (
    <ConfirmModal
      isOpen={isOpen}
      title="Confirm Deletion of Marking Work"
      handleClickCancel={onClose}
      handleClickOK={onConfirm}
      actionPair={ConfirmModalActionPair.Custom}
      buttonTitleOK="Confirm Deletion of Marking Work"
      buttonTitleCancel="Cancel"
    >
      <p>To force reallocate the response, existing marking work must be deleted.</p>
      <Alert variant="danger">
        <b>{countMessages(oldMarkerId, marksOfResponse)}</b> marked by{' '}
        <FullName organisationUser={oldOrganisationUser} bringAttentionTo /> will be deleted.
      </Alert>
      <p>Are you sure you want to delete this marking work? This cannot be undone.</p>
    </ConfirmModal>
  );
}
